import axiosClient, { axiosClientCached } from "../";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class SportsService {
  static getSports(params) {
    return axiosClient
      .get("/sb/getSports", { params })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static getCountries(payload) {
    return axiosClient
      .get("/sb/getCountries", {
        params: {
          sportId: payload?.sportsId,
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        console.log(error);
        return getErrorMessageObj(error);
      });
  }

  static getLeagues({ payload }) {
    return axiosClient
      .get("/sb/getLeagues", {
        params: { ...payload }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static getTopLeagues({ payload }) {
    return axiosClientCached
      .get("/sb/getTopLeagues", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static getTopSports({ payload }) {
    return axiosClient
      .get("sb/getSports", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static async getBannersData(params) {
    return axiosClientCached
      .get("user/getBanner", {
        params
      })
      .then(({ data }) => {
        return data?.data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static getPopularCountry({ payload }) {
    return axiosClientCached
      .get("sb/getPopularCountry", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
